<template>
  <QPaginatedSearchDropdown :value="value" :list-getter="getProjectListFromFilter" :filter="filter"
    :min-search-char-limit="0" :externaledit="externaledit" :clearable="clearable" :multiple="multiple"
    :returnobject="returnobject" :disabled="disabled" :loading="loading" valuekey="Id" textkey="Name"
    :label="label ? label : $t('servicesystem.common_objects.project.project')" :singleline="singleline"
    :placeholder="placeholder ? placeholder : $t('servicesystem.common_objects.project.search_field_label')"
    @input="e => $emit('input', e)" @FocusState="e => $emit('FocusState', e)">

    <template v-if="!hideIcon" v-slot:prepend-outer>
      <v-icon size="20">mdi-folder-pound</v-icon>
    </template>

    <!-- 
    <template v-if="!multiple" v-slot:selection="{ item }">
      <span style="color: var(--v-primary-base);">{{ item.ProjectNumber }}</span>&nbsp;-&nbsp;{{ item.Name }}
    </template>
    -->

  </QPaginatedSearchDropdown>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";

export default {
  name: "ProjectSelect2",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    filter: Object,
    returnobject: Boolean,
    multiple: Boolean,
    hideIcon: Boolean,
    singleline: Boolean,
  },
  components: {
    QPaginatedSearchDropdown,
  },
  mixins: [clientAPI, rules],

  data() {
    return {
    };
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>